import * as React from "react";
import { Card, Box } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

export default function WhyUsCard(props) {
	return (
		<Card
			sx={{
				width: { xs: "250px", md: "410px" },
				height: { xs: "330px", md: "250px" },
				gap: 1,
				borderRadius: 4,
				p: 1,
			}}
		>
			<Box height={"100%"}>
				<Box height={"45%"} width={"100%"} sx={{ aspectRatio: "10/9" }}>
					<CardMedia
						sx={{
							height: "100%",
							// width: { xs: 285, md: 370 }
							width: "100%",
							objectFit: "cover",
							// height: 112
						}}
						image={props.image}
						title="green iguana"
					/>
				</Box>
				<Box height={"55%"}>
					<CardContent>
						<Typography
							gutterBottom
							fontWeight={600}
							fontSize={{ xs: 20, md: 22 }}
						>
							{props.title}
						</Typography>
						<Typography
							fontWeight={400}
							fontSize={13}
							sx={{ color: "#667085" }}
						>
							{props.description}
						</Typography>
					</CardContent>
				</Box>
				{/* <Box height={"30%"}></Box> */}
			</Box>
		</Card>
	);
}
